<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('container_view')" :directory="$t('datatables')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button"
                            class="btn btn-primary btn-with-shadow"
                            @click="redirectToContainer()">
                        {{ $t('back_to_containers') }}
                    </button>
                </div>
            </div>
        </div>
        <div class="container_view mb-primary">
            <div class="card position-relative card-with-shadow py-primary border-0">
                <app-overlay-loader v-if="componentLoader" class="h-100"/>
                <div v-else class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-5">
                        <div class="media border-right px-5 pr-xl-5 pl-xl-0 align-items-center user-header-media">
                            <form class="mb-0" ref="form" data-url="admin/auth/container/container-picture"
                                  :class="{'loading-opacity': preloader}">
                                <div class="container-pic-wrapper position-relative">
                                    <app-overlay-loader v-if="preloader"/>
                                    <app-input v-else
                                               id="container_image"
                                               class="circle mx-xl-auto"
                                               :wrapper-class="'circle mx-xl-auto'"
                                               name="container_image"
                                               type="custom-file-upload"
                                               v-model="this.containerdata.container_picture"
                                               :generate-file-url="false"
                                               @change="setContainerPicture"
                                               :label="$t('change')"/>
                                </div>
                            </form>
                            <div class="media-body user-info-header">
                                <h5>
                                    {{ this.containerdata.name }}
                                </h5>
                                <p class="text-muted mb-2">{{ this.containerdata.container_domain }}</p>
                                <span :class="'badge badge-pill badge-' + $t('badge-'+this.containerdata.badgestatus) + ' user-status'">{{ $t(this.containerdata.status) }}</span>
                                <div class="social-links pt-3">
                                    <a class="mr-3" v-for="socialLink in user.socialLinks"
                                       v-if="socialLink.link" :href="socialLink.link" target="_blank">
                                        <app-icon class="mb-1" :name="socialLink.icon" width="16" height="16"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7">
                        <div class="user-details px-5 px-sm-5 px-md-5 px-lg-0 px-xl-0 mt-5 mt-sm-5 mt-md-0 mt-lg-0 mt-xl-0">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                    <div class="border-right custom">
                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon :name="'upload-cloud'"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('plan') }}:</p>
                                                <p class="mb-0">{{
                                                        this.containerdata.plan ? this.containerdata.plan : $t('not_available')
                                                    }}</p>
                                            </div>
                                        </div>
                                        <div class="media mb-4 mb-xl-0">
                                            <div class="align-self-center mr-3">
                                                <app-icon :name="'activity'"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('requests') }}:</p>
                                                <p class="mb-0">{{
                                                        this.containerdata.requests ? this.containerdata.requests+' / '+ this.containerdata.booked_requests: $t('not_available')
                                                    }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                    <div class="media mb-4 mb-xl-5">
                                        <div class="align-self-center mr-3">
                                            <app-icon :name="'calendar'"/>
                                        </div>
                                        <div class="media-body">
                                            <p class="text-muted mb-0">{{ $t('created') }}:</p>
                                            <p class="mb-0">{{ format_date(this.containerdata.created_at) }}</p>
                                        </div>
                                    </div>
                                    <div class="media mb-0 mb-xl-0">
                                        <div class="align-self-center mr-3">
                                            <app-icon :name="'refresh-cw'"/>
                                        </div>
                                        <div class="media-body">
                                            <p class="text-muted mb-0">{{ $t('updated') }}:</p>
                                            <p class="mb-0">{{ format_date(this.containerdata.updated_at) }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-tab :tabs="tabs" :icon="tabIcon"/>
    </div>
</template>

<script>

import Vue from 'vue'
import {FormMixin} from "../../../../core/mixins/form/FormMixin";
import {UserMixin} from "../Auth/Mixins/UserMixin";
import {TableHelpers} from "./Mixins/TableHelpers";
import * as actions from "../../../Config/ApiUrl";
import {urlGenerator} from "../../../Helpers/AxiosHelper";
import moment from 'moment';
import VueRouter from 'vue-router';

Vue.use(VueRouter)
import ContainerDatatable from './ContainerDatatable.vue';

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
});

export default {
    name: "ContainerSingle",
    props: {
        containerId: String
    },
    mixins: [FormMixin, UserMixin, TableHelpers],
    data() {
        return {
            preloader: false,
            containerdata: [],
            ContainerDatatable: '',
            container_picture: '',
            tabIcon: 'settings',
            tabs: [
                {
                    'name': this.$t('domain_settings'),
                    'title': this.$t('domain_settings'),
                    'component': 'domain-settings',
                    'permission': ''
                },
                {
                    'name': this.$t('password_change'),
                    'title': this.$t('password_change'),
                    'component': 'password-change',
                    'permission': ''
                },
                {
                    'name': this.$t('social_links'),
                    'title': this.$t('social_links'),
                    'component': 'social-links',
                    'permission': ''
                }
            ]
        }
    },
    mounted() {
        this.fetchUsers(this.containerId);
        //this.$store.state.container.containerid = this.containerId;
        //$store.commit('containerId', this.containerId);
    },
    methods: {
        beforeSubmit() {
            this.preloader = true;
        },
        redirectToContainer() {
            //router.push({ path: '/container', beforeEnter() {location.href = '/container'}})
            window.location = '/container'
        },
        format_date(value) {
            if (value) {
                let date = moment.parseZone(value);
                let tzDate = moment(new Date(date.get('year'), date.get('month'), date.get('date'), date.get('hour'), date.get('minute'))).add(new Date().getTimezoneOffset()*-1, 'm').format('MM/DD/YYYY hh:mm A');
                return tzDate;
            }
        },
        fetchUsers(containerId) {
            fetch(urlGenerator(actions.CONTAINERTABLE_DATA+'/'+containerId)) // Hier müsste die URL der Ajax-Quelle eingefügt werden
                .then(response => response.json())
                .then(data => {
                this.containerdata = data;
                this.containerdata.badgestatus = data.status.toLowerCase();
                })
                .catch(error => {
                console.error('Fehler beim Abrufen der Containerdaten:', error);
                });
            
        },
        setContainerPicture($event) {
            const fileValue = $event.target.files[0];
            let formData = new FormData();
            formData.append('container_picture', fileValue);
            this.save(formData);
        },
        afterFinalResponse() {
            this.preloader = false;
        },
        afterSuccess(res) {
            this.$toastr.s(res.data.message);
            window.location = urlGenerator(actions.CONTAINER_SINGLE);
        },
    }
}

</script>
<style scoped>
    .container_view .card{
        min-height: 190px;
    }
</style>
